// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__94qF5","header":"styles_header__9M-Em","close":"styles_close__G05je","list":"styles_list__gE62n","row":"styles_row__iSFAg"};